"use strict";

exports.__esModule = true;
exports.awaitFor = void 0;
var awaitFor = exports.awaitFor = function awaitFor(promise) {
  return promise.then(function (data) {
    return [null, data];
  })["catch"](function (err) {
    return [err, null];
  });
};